import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Produit } from 'app/models/produit';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { ProduitsService } from 'app/services/produits/produits.service';
import { AwscontrolService, UploadResponse, DeleteResponse } from 'app/services/aws/awscontrol.service';
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { Location } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-modifier-produit',
  templateUrl: './modifier-produit.component.html',
  styleUrls: ['./modifier-produit.component.scss']
})
export class ModifierProduitComponent implements OnInit {

  produit: Produit = new Produit();
  
  // Form Controls
  numCommercialFormControl: FormControl;
  emailCommercialFormControl: FormControl;
  
  // File handling
  selectedFiles: FileList | null = null;
  fileNames: any[] = [];
  allAttch: any[] = [];
  
  // Images
  public image: string = '';
  public imagePromo: string = '';
  
  // Data
  public prodAgence: any;
  public idProduitAgency: any;
  agenciesApp: any;
  dataSource = new MatTableDataSource();
  
  // Loading states
  isUploading: boolean = false;
  isSubmitting: boolean = false;
  isLoading: boolean = true;

  // Track which image is being uploaded
  currentUploadType: 'main' | 'promo' = 'main';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private agenceProduit: ProduitsService,
    private agenciesService: AgenciesService,
    private awsService: AwscontrolService
  ) {
    this.numCommercialFormControl = new FormControl('');
    this.emailCommercialFormControl = new FormControl('', [Validators.email]);
  }

  ngOnInit(): void {
    this.agenceProduit.refreshNedeed.subscribe(() => this.getData());
    this.getData();
  }

  getData(): void {
    this.isLoading = true;
    this.idProduitAgency = this.activatedRoute.snapshot.paramMap.get('id');

    this.agenceProduit.getProduit(this.idProduitAgency).subscribe(
      data => {
        this.produit = data;
        this.image = data.imageUrl || '';
        this.imagePromo = data.promoImg || '';
        
        if (this.image) this.allAttch[0] = this.image;
        if (this.imagePromo) this.allAttch[1] = this.imagePromo;
        
        if (data.numCommercial) {
          this.numCommercialFormControl.setValue(data.numCommercial);
        }
        if (data.emailCommercial) {
          this.emailCommercialFormControl.setValue(data.emailCommercial);
        }
        
        // Ensure categoryList is an array for p-chips (if backend sends string, split it)
        if (this.produit.categoryList && typeof this.produit.categoryList === 'string') {
          this.produit.categoryList = (this.produit.categoryList as string).split(',').filter(c => c.trim());
        } else if (!this.produit.categoryList) {
          this.produit.categoryList = [];
        }
        
        // Defaults for other fields
        if (!this.produit.status) this.produit.status = 'actif';
        if (!this.produit.categorie) this.produit.categorie = '';
        
        this.isLoading = false;
      },
      error => {
        console.error('Error loading product:', error);
        this.isLoading = false;
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Erreur lors du chargement du produit",
        });
      }
    );

    this.agenciesService.getList().subscribe(
      (data) => {
        this.agenciesApp = data;
      },
      error => {
        console.error('Error loading agencies:', error);
      }
    );
  }

  private getRandomString(length: number): string {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  selectFileimg(e: any): void {
    this.selectedFiles = e.target.files;
    this.currentUploadType = 'main';
    this.uploadimg2();
  }

  uploadimg2(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) return;
    this.isUploading = true;
    const file = this.selectedFiles[0];
    this.uploadFileToAws(file, 'main');
  }

  selectFileimgPromo(e: any): void {
    this.selectedFiles = e.target.files;
    this.currentUploadType = 'promo';
    this.uploadimgPromo();
  }

  uploadimgPromo(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) return;
    this.isUploading = true;
    const file = this.selectedFiles[0];
    this.uploadFileToAws(file, 'promo');
  }

  uploadFileToAws(file: File, type: 'main' | 'promo'): void {
    if (!file) return;
    this.isUploading = true;
    this.fileNames.push(file.name);
    const folder = 'products';

    this.awsService.uploadFile(file, folder)
      .pipe(finalize(() => this.isUploading = false))
      .subscribe(
        (response: UploadResponse) => {
          if (response.success && response.urls && response.urls.length > 0) {
            const uploadedUrl = response.urls[0];
            if (type === 'main') {
              this.image = uploadedUrl;
              this.allAttch[0] = uploadedUrl;
              localStorage.setItem('prodImg', JSON.stringify(uploadedUrl));
              Swal.fire({
                icon: "success",
                title: "Image téléchargée",
                text: "Image principale téléchargée avec succès",
                timer: 1500
              });
            } else {
              this.imagePromo = uploadedUrl;
              this.allAttch[1] = uploadedUrl;
              localStorage.setItem('promoImg', JSON.stringify(uploadedUrl));
              Swal.fire({
                icon: "success",
                title: "Image téléchargée",
                text: "Image promotionnelle téléchargée avec succès",
                timer: 1500
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: response.error || "Échec du téléchargement",
            });
          }
        },
        (error) => {
          console.error('Upload error:', error);
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Erreur lors du téléchargement de l'image",
          });
        }
      );
  }

  deleteImage(imageUrl: string, type: 'main' | 'promo'): void {
    if (!imageUrl) return;

    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Cette action est irréversible!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.awsService.deleteFile(imageUrl).subscribe(
          (response: DeleteResponse) => {
            if (response.status === 'success') {
              if (type === 'main') {
                this.image = '';
                this.allAttch[0] = '';
              } else {
                this.imagePromo = '';
                this.allAttch[1] = '';
              }
              Swal.fire({
                icon: 'success',
                title: 'Supprimé!',
                text: "L'image a été supprimée.",
                timer: 1500
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: response.error || "Échec de la suppression",
              });
            }
          },
          (error) => {
            console.error('Delete error:', error);
            Swal.fire({
              icon: 'error',
              title: 'Erreur',
              text: "Erreur lors de la suppression",
            });
          }
        );
      }
    });
  }

  validateForm(): boolean {
    if (!this.produit.name || this.produit.name.trim() === '') {
      Swal.fire({ icon: "error", title: "Erreur", text: "Le nom du produit est requis" });
      return false;
    }
    if (this.emailCommercialFormControl.value && this.emailCommercialFormControl.invalid) {
      Swal.fire({ icon: "error", title: "Erreur", text: "Email commercial invalide" });
      return false;
    }
    return true;
  }

  updateProduitAgencies(): void {
    if (!this.validateForm()) return;
    if (this.isUploading) {
      Swal.fire({
        icon: "warning",
        title: "Téléchargement en cours",
        text: "Veuillez attendre la fin du téléchargement des images",
      });
      return;
    }

    this.isSubmitting = true;

    // Convert categoryList from array to comma-separated string (backend likely expects string)
    let categoryValue: string = '';
    if (this.produit.categoryList) {
      if (Array.isArray(this.produit.categoryList)) {
        categoryValue = this.produit.categoryList.join(',');
      } else if (typeof this.produit.categoryList === 'string') {
        categoryValue = this.produit.categoryList;
      }
    }

    const updatedProduct: any = {
      id: this.produit.id,
      name: this.produit.name,
      description: this.produit.description,
      prix: this.produit.prix,
      categoryList: categoryValue,  // send as string: "cat1,cat2,cat3"
      imageUrl: this.image || this.produit.imageUrl,
      promoImg: this.imagePromo || this.produit.promoImg,
      promoTitle: this.produit.promoTitle,
      videoUrlProduit: this.produit.videoUrlProduit,
      nomCommercial: this.produit.nomCommercial,
      numCommercial: this.numCommercialFormControl.value,
      emailCommercial: this.emailCommercialFormControl.value,
      status: this.produit.status || 'actif',
      categorie: this.produit.categorie || '',
      // Do NOT send agencyName – backend likely has a relation
      // Do NOT send displayOrder – we ignore it
    };

    // Optional: remove any undefined fields
    Object.keys(updatedProduct).forEach(key => {
      if (updatedProduct[key] === undefined) delete updatedProduct[key];
    });

    console.log('Sending update payload:', updatedProduct); // Debug

    this.agenceProduit.updateProduit(this.idProduitAgency, updatedProduct).subscribe(
      (response: any) => {
        this.isSubmitting = false;
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Produit modifié avec succès",
          timer: 2000
        });
        setTimeout(() => this.navigateBack(), 500);
      },
      (error: HttpErrorResponse) => {
        this.isSubmitting = false;
        console.error("HTTP Error:", error);
        let errorMsg = "Une erreur s'est produite lors de la modification du produit";
        if (error.error?.message) errorMsg = error.error.message;
        else if (error.error?.text) {
          // Backend might return success message in error.text
          Swal.fire({ icon: "success", title: "Succès", text: error.error.text });
          setTimeout(() => this.navigateBack(), 500);
          return;
        }
        Swal.fire({ icon: "error", title: "Erreur", text: errorMsg });
      }
    );
  }

  navigateBack(): void {
    this.location.back();
  }

  getFileNameFromUrl(url: string): string {
    if (!url) return '';
    return url.substring(url.lastIndexOf('/') + 1);
  }
}